export default __webpack_public_path__ + "static/media/02.3cc71569.gif";